import { all } from "redux-saga/effects";

import attendant from "./attendant/sagas";
import interaction from "./interaction/sagas";
import form from "./form/sagas";

export default function* rootSaga() {
  return yield all([attendant, interaction, form]);
}
